(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.pdf
  (:require
   [clojure.string :as string]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.page.lp-portal.report.pdf.view :as report]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view :as stacked-text-group]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as pdf-page]
   [frontend.ui.component.lp-portal.table.pdf.view :as pdf-table]))

(defn epc-row
  [cls target acquisition]
  (let [image (str "EPC_" cls)]
    {:columns
     [{:stack  [{:image image
                 :width 50}]
       :margin [0 0 0 0]
       :width  60}
      {:stack (concat []
                      (when (= target cls)
                        [{:text     "Target during holding period"
                          :fontSize (if (= acquisition cls)
                                      7
                                      8)
                          :margin   [0
                                     (if (= acquisition cls)
                                       0
                                       6)
                                     0 0]}])
                      (when (= acquisition cls)
                        [{:text     (str (if (= target cls)
                                           "and a"
                                           "A")
                                         "t acquisition status")
                          :fontSize (if (= target cls)
                                      7
                                      8)
                          :margin   [0
                                     (if (= target cls)
                                       0
                                       6)
                                     0 0]}]))}]}))

(defn esg-pages
  [report-data]
  (let [target-class (:energy-performance-certificate-target report-data)
        acquisition-class (:energy-performance-certificate-at-acquisition report-data)
        eu-taxonomy-alignment (:eu-taxonomy-alignment report-data)
        green-building-certifications-set (-> (:green-building-certification report-data)
                                              (string/split #";")
                                              (set))]
    [(page/page
      nil
      (page/page-title {:page-title (str (:holding-name report-data) " - Sustainability")})
      (column/columns
       (column/column
        (card/card
         "Energy Performance Certificate (energy class)"
         [(epc-row "A" target-class acquisition-class)
          (epc-row "B" target-class acquisition-class)
          (epc-row "C" target-class acquisition-class)
          (epc-row "D" target-class acquisition-class)
          (epc-row "E" target-class acquisition-class)
          (epc-row "F" target-class acquisition-class)
          (epc-row "G" target-class acquisition-class)
          (card/card
           "Status now"
           (text-content/rich-content (->> report-data
                                           :energy-performance-status
                                           :rich-content)))]))
       (column/column
        (card/card
         "Green building certification"
         (concat []
                 (when (get green-building-certifications-set "breeam")
                   [{:image "breeam"
                     :width 100}])
                 (when (get green-building-certifications-set "dgnb")
                   [{:image "dgnb"
                     :width 100}])
                 (when (get green-building-certifications-set "usgbc")
                   [{:image "usgbc"
                     :width 100}])
                 [(card/card
                   "Target and status now"
                   (text-content/rich-content (->> report-data
                                                   :green-building-status
                                                   :rich-content)))])))
       (column/column
        (card/card
         "EU Taxonomy"
         (concat
          []
          [{:text eu-taxonomy-alignment}]
          (when (= "Not aligned" eu-taxonomy-alignment)
            [(card/card
              "Plan to be aligned"
              (text-content/rich-content (->> report-data
                                              :eu-taxonomy-plan
                                              :rich-content)))])
          [(card/card
            "Other sustainability developments"
            (text-content/rich-content (->> report-data
                                            :other-esg-development
                                            :rich-content)))])))))]))

(defn portfolio-esg-pages
  [report-data]
  (let [sqm-pct (:green-building-certification-sqm-pct report-data)
        epc-counts (:energy-performance-counts report-data)
        certified-count (:green-building-certification-certified-count report-data)
        total-count (:green-building-certification-total-count report-data)
        eu-taxonomy-alignment (:eu-taxonomy-alignment report-data)]
    [(page/page
      nil
      (page/page-title {:page-title (str (:holding-name report-data) " - Sustainability")})
      (column/columns
       (column/column
        (card/card
         "Energy Performance Certificate (energy class)"
         [(table/raw-table [["EPC" "Number of properties"]
                            ["EPC A" (get epc-counts "EPC A" "")]
                            ["EPC B" (get epc-counts "EPC B" "")]
                            ["EPC C" (get epc-counts "EPC C" "")]
                            ["EPC D" (get epc-counts "EPC D" "")]
                            ["EPC E" (get epc-counts "EPC E" "")]
                            ["EPC F" (get epc-counts "EPC F" "")]
                            ["EPC G" (get epc-counts "EPC G" "")]
                            ["No EPC" (get epc-counts "No EPC" "")]])
          (card/card
           "Notes"
           (text-content/rich-content (->> report-data
                                           :energy-performance-status
                                           :rich-content)))]))
       (column/column
        (card/card
         "Green building certification"
         [(table/raw-table [["Share of certified properties" ""]
                            ["Certified sqm %" sqm-pct]
                            ["Certified number of properties" (str certified-count "/" total-count)]])
          (card/card
           "Notes"
           (text-content/rich-content (->> report-data
                                           :green-building-status
                                           :rich-content)))]))
       (column/column
        (card/card
         "EU Taxonomy alignment"
         (concat
          []
          [{:text eu-taxonomy-alignment}]
          (when (= "Not aligned" eu-taxonomy-alignment)
            [(card/card
              "Plan to be aligned"
              (text-content/rich-content (->> report-data
                                              :eu-taxonomy-plan
                                              :rich-content)))])
          (when-let [notes (->> report-data
                                :eu-taxonomy-notes
                                :rich-content)]
            [(card/card
              "Notes"
              (text-content/rich-content notes))])
          [(card/card
            "Other sustainability initiatives/improvements"
            (text-content/rich-content (->> report-data
                                            :other-esg-development
                                            :rich-content)))])))))]))
